import { format } from "date-fns";

import { Icon } from "@/components/common/Icon";
import { InputDatePicker } from "@/components/common/inputs/InputDatePicker";
import { useForm } from "@/hooks/common/use-form";
import { formatDateInSaoPauloTimeZone, isoDateToDate } from "@/utils/date";

interface Props {
  onSelectDate: (date: string) => void;
  selectedDate: string;
}

export const SelectScheduleDatePopover = ({ onSelectDate, selectedDate }: Props): JSX.Element => {
  const { control } = useForm({
    handleSubmit: async () => null,
    fields: { date: { validation: "none" } },
    initialValues: { date: isoDateToDate(selectedDate) },
  });

  const handleSelect = () => {
    const date = control.getValue("date") as Date | null;

    if (date) {
      onSelectDate(format(date, "yyyy-MM-dd"));
    }
  };

  return (
    <InputDatePicker
      control={control}
      field="date"
      className="!ml-2 !inline-flex !w-fit [&_.react-datepicker\\_\\_input-container]:!overflow-visible [&_.react-datepicker\\_\\_input-container]:!flex"
      minDate={isoDateToDate(formatDateInSaoPauloTimeZone()) ?? undefined}
      hideRemoveFilterButton
      showIcon={false}
      popperPlacement="bottom-start"
      customInput={
        <button type="button" aria-label="Selecionar data da agenda" className="!p-0 !border-0">
          <Icon name="Calendar" className="!static text-primary" />
        </button>
      }
      popperClassName="[&_.react-datepicker\\_\\_month-container]:!w-full"
      applyLabel="Ver agendamentos"
      onApply={handleSelect}
    />
  );
};
